export default __webpack_public_path__ + "static/media/M2HairSalon-4.1fe8c541.jpg";